import { render, staticRenderFns } from "./HomeTopImage.vue?vue&type=template&id=680ecd22&scoped=true"
import script from "./HomeTopImage.vue?vue&type=script&lang=js"
export * from "./HomeTopImage.vue?vue&type=script&lang=js"
import style0 from "./HomeTopImage.vue?vue&type=style&index=0&id=680ecd22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680ecd22",
  null
  
)

export default component.exports